import React, { useEffect, useState, useCallback } from "react";
import {
  Button,
  Typography,
  Radio,
  Box,
  FilledInput,
  InputAdornment,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { get } from "../../../services/apiService";
import BackdropLoader from "../../common/BackdropLoader";
import DomainGuidelinesSection from "../../domain-guidlines/DomainGuidLines";
import i18next from "i18next";
import { useAuth } from "../../../hooks/useAuth";

// Moved outside component since it doesn't depend on any props/state
const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const DomainForm = ({ screenWidth, onDomainContinue }) => {
  const [selectedRadio, setSelectedRadio] = useState(i18next.t("DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_NEW_DOMAIN"));
  const { currentLang } = useAuth();
  const [domainObject, setDomainObject] = useState({});
  const [validSubdomainError, setValidSubdomainError] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const [domainName, setDomainName] = useState('');
  const [sections, setSections] = useState([
    { label: "DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_NEW_DOMAIN", value: "", postfix: "", placeholder: "", isSelected:false, },
    {
      label: "DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_DOMAIN",
      value: "",
      postfix: ".microband.online",
      placeholder: "seulah",
      isSelected:false,
    },
    {
      label: "DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_ANOTHER_DOMAIN",
      value: "",
      postfix: "",
      placeholder: "seulah.com",
      isSelected:false,
    },
  ]);
  const [domainIndex, setDomainIndex] = useState(0);

  const getOneMonthFromToday = useCallback(() => {
    const today = new Date();
    const oneMonthFromToday = new Date(today);
    oneMonthFromToday.setMonth(today.getMonth() + 1);
    return formatDate(oneMonthFromToday);
  }, []); // No dependencies needed now since formatDate is stable

  const themeIdString = sessionStorage.getItem("themeId") || "1";
  const themeIdNumber = Number(themeIdString);

  function isValidDomainName(domainName) {
    const domainRegex = /^(?!-)(?!.*--)[a-z0-9-]{1,63}(?<!-)$/;
    return domainRegex.test(domainName);
  }

  const handleInputChange = (index, event) => {
    const updatedSections = [...sections];
    updatedSections[index].value = event.target.value;
    setSections(updatedSections);

    if (index === 1) {
      setDomainName(event.target.value);
      if (isValidDomainName(event.target.value) || event.target.value === '') {
        setDomainObject({
          themeId: themeIdNumber,
          domainName: event.target.value,
          expiryDate: getOneMonthFromToday(),
          domainStatus: 'registered',
          isMicroband: true,
          price: 0,
        });
        setValidSubdomainError('');
      } else {
        setValidSubdomainError("DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_DOMAIN_MESSAGE");
      }
    } else {
      setValidSubdomainError('');
      setDomainObject({
        themeId: themeIdNumber,
        domainName: event.target.value,
        expiryDate: getOneMonthFromToday(),
        domainStatus: index === 0 ? 'purchased' : 'personal',
        isMicroband: false,
        price: 0,
      });
    }
  };

  const handleRadioChange = (index, sectionLabel) => {
      console.log('current label------------->', sectionLabel);
      sections[index].isSelected = true;
      sections.forEach((section,sectionIndex)=>{
        section.isSelected = sectionIndex === index;
      })
      setSelectedRadio(i18next.t(sectionLabel)); 
    setDomainIndex(index);

    if (index === 1 && !isValidDomainName(domainName)) {
      console.log('domain name----------->', domainName);
      console.log('section label-------------->', sectionLabel);
      setValidSubdomainError(i18next.t('DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_DOMAIN_MESSAGE'));
    } else {
      setValidSubdomainError('');
    }
  };

  const isAnySelected = sections.find((section) => {
    return section.isSelected;
  })?.isSelected ?? false

  const userId = sessionStorage.getItem("userId");
  
  const onLoading = useCallback((isLoading) => {
    setIsLoading(isLoading);
  }, []);

  const getUserDomain = useCallback(async () => {
    const domain = await get(`users/domain/${userId}`, {}, onLoading);
    const domainName = domain?.data?.domainName;
    const domainStatus = domain?.data?.domainStatus;
    const isMicroband = domain?.data?.isMicroband;
  
    console.log('inside getUserDomain domain name-------->', domainName);
    setDomainName(domainName);
  
    if (domainName?.length > 0) {
      const updatedSections = sections.map(section => ({ ...section }));
      let radioLabel = "";
      let index = 0;
  
      if (domainStatus === 'purchase') {
        updatedSections[0].value = domainName;
        radioLabel = i18next.t("DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_NEW_DOMAIN");
        updatedSections[0].isSelected = true;
        index = 0;
      } else if (isMicroband === true) {
        updatedSections[1].value = domainName;
        radioLabel = i18next.t("DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_DOMAIN");
        index = 1;
        updatedSections[1].isSelected = true;
      } else {
        updatedSections[2].value = domainName;
        radioLabel = i18next.t("DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_ANOTHER_DOMAIN");
        index = 2;
        updatedSections[2].isSelected = true;
      }
  
      setSections(updatedSections);
      console.log('api radio label:', radioLabel);
      setSelectedRadio(radioLabel);

      setDomainObject({
        themeId: themeIdNumber,
        domainName,
        expiryDate: getOneMonthFromToday(),
        domainStatus,
        isMicroband,
        price: 0,
      });
      setDomainIndex(index);
    }
  }, [userId, onLoading, sections, themeIdNumber, getOneMonthFromToday]);

  useEffect(() => {
    getUserDomain();
  }, [currentLang, getUserDomain]);

  useEffect(() => {
    console.log('selected radio----------->', selectedRadio);
  }, [sections, isAnySelected, selectedRadio]);

  return (
    <Grid
      container
      spacing={3}
      justifyContent="center"
      alignItems="center"
      sx={{ padding: screenWidth > 1000 ? "3% 20%" : "3% 5%" }}
    >
      {isLoading && <BackdropLoader />}
      <Grid item size={{ xs: 12 }} sx={{ marginBottom: "7%" }}>
        <Typography
          variant="h4"
          align="center"
          sx={{ fontFamily: "Tajawal-Bold", fontSize: "40px", color: "black" }}
        >
          {i18next.t("DOMAIN_SELCTION_PAGE_HEADING_1")}
        </Typography>
      </Grid>

      {sections.map((section, index) => (
        <Grid key={index} container item size={{ xs: 12 }} alignItems="center" spacing={2}>
          <Grid item size={{ md: 5, xs: 8 }}>
            <Typography sx={{ fontFamily: "Tajawal-Regular", fontSize: "24px", color: "#575452" }}>
              {i18next.t(section.label)}
            </Typography>
          </Grid>
          <Grid item size={{ md: 5, xs: index > 0 ? 10 : 2 }}>
            {index > 0 && (
              <Box sx={{ display: "flex" }}>
                <FilledInput
                  endAdornment={<InputAdornment position="end">{section.postfix}</InputAdornment>}
                  placeholder={section.placeholder}
                  fullWidth
                  value={section.value}
                  onChange={(e) => handleInputChange(index, e)}
                  sx={{
                    fontFamily: "Tajawal-Regular",
                    fontSize: "24px",
                    color: "#575452",
                    "& .MuiInput-underline:before": { borderBottomColor: "black" },
                    "& .MuiInput-underline:after": { borderBottomColor: "black" },
                  }}
                />
              </Box>
            )}
            {index === 1 && validSubdomainError.length > 0 && (
              <Box>
                <Typography sx={{ fontSize: "12px", color: "red", marginTop: "1.5%" }}>
                  {i18next.t(validSubdomainError)}
                </Typography>
              </Box>
            )}
          </Grid>
          <Grid item size={{ xs: 2 }}>
            <Radio
              checked={section.isSelected}
              value={i18next.t(section.label)}
              onChange={() => handleRadioChange(index, section.label)}
              sx={{
                color: "black",
                "&.Mui-checked": { color: "#575452" },
                width: "50px",
                height: "50px",
              }}
            />
          </Grid>
        </Grid>
      ))}

      {selectedRadio === i18next.t("DOMAIN_SELCTION_PAGE_FORM_FIELD_LABEL_USE_ANOTHER_DOMAIN") && (
        <Grid container item size={{ xs: 12 }} alignItems="center" spacing={2}>
          <DomainGuidelinesSection />
        </Grid>
      )}

      {isAnySelected && (
        <Grid item size={{ xs: 12 }} textAlign="center" sx={{ marginTop: "7%" }}>
          <Button
            variant="contained"
            onClick={() => onDomainContinue(domainIndex, domainObject)}
            disabled={validSubdomainError.length > 0}
            sx={{
              background: "linear-gradient(to right, #004D8A, #02599C, #0886E1, #0A91F2)",
              color: "#F0F0F0",
              width: screenWidth > 600 ? "30%" : "50%",
              fontSize: screenWidth > 600 ? "32px" : "24px",
              fontFamily: "Tajawal-Bold",
              padding: "10px 20px",
              borderTopLeftRadius: "15px",
              borderBottomRightRadius: "15px",
            }}
          >
            {i18next.t("DOMAIN_SELCTION_PAGE_BUTTON_LABEL_SAVE")}
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default DomainForm;